export default {
  auth: {
    email: "E-Mail",
    password: "Passwort",
    logout: "Logout",
    sign_in: "Login",
    login_screen: "login screen",
    back_to_sign_in: "zurück zum Log-In",
    reset_password: "Passwort zurücksetzen",
    reset_password_code: "Passwort-Code zurücksetzen",
    forget_password: "Passwort vergessen",
    new_password: "Neues Passwort",
    re_new_password: "Neues Passwort",
    login_failed: "Identität nicht gefunden",
    change_password: "Passwort ändern",
    continue: "Weiter",
    password_change_successfully: "Ihr Passwort wurde erfolgreich aktualisiert",
    showcase: {
      welcome: "Willkommen^3000",
      cloud: "Die neue Generation der Identifizierungs- und Managements-Cloudplattform^4000",
      identify:
        "identifizieren, tracken und managen Sie ihr Workforce^1000 auf benutzerfreundliche und sichere Art und Weise^4000",
      manage: "Sie können jederzeit und von überall aus managen^4000",
      freedom: "Sie haben die Freiheit^3000 jegliche Systeme jederzeit einzusehen^3000"
    },
    login_with_amazon: "Login With Amazon",
    login_with_google: "Login With Google",
    update_password: "Update Password",
    email_not_found: "This email address was not found",
    invalid_reset_token: "Invalid reset code",
    password_reset_code_sent_to_email: "Your password reset code has been sent to your e-mail address",
    passwordExpireNotificationMessage:
      "There are 0 day left until your password expires | There are 1 day left until your password expires | There are {count} days left until your password expires"
  }
};
